import { render, staticRenderFns } from "./CourseDrawer.vue?vue&type=template&id=5849f794&scoped=true&"
import script from "./CourseDrawer.vue?vue&type=script&lang=js&"
export * from "./CourseDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CourseDrawer.vue?vue&type=style&index=0&id=5849f794&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5849f794",
  null
  
)

export default component.exports